import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../ui-kit/theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flex: "1 1 0",
      minWidth: 0,
      border: `1px solid ${UIKIT_COLORS.DANGER_BORDER}`,
      borderRadius: 8,
      backgroundColor: UIKIT_COLORS.DANGER_BG,
      padding: "10px 13px 12px",
      boxSizing: "border-box" as const,
    },
    headerRow: {
      display: "flex",
      alignItems: "center",
      "& > * + *": { marginLeft: 8 },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_MUTED,
      letterSpacing: "0.3px",
      textTransform: "uppercase" as const,
      lineHeight: "16px",
    },
    undoBtn: {
      flexShrink: 0,
      marginLeft: "auto",
      fontSize: 11,
      fontWeight: 500,
      color: `${UIKIT_COLORS.TEXT_SECONDARY} !important`,
      textDecoration: "underline",
      textTransform: "none" as const,
      padding: "0 2px",
      minWidth: "unset",
      "&:hover": { background: "transparent", color: `${UIKIT_COLORS.DANGER} !important` },
    },
    value: {
      marginTop: 6,
      fontSize: 14,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      wordBreak: "break-word" as const,
      whiteSpace: "pre-wrap" as const,
    },
  })
);
